// extracted by mini-css-extract-plugin
export default {"page_content":"Notice_page_content__rsveP"};